import React, { useCallback, useMemo, useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../Layouts/PageInfoAndActionBar";
import { useFormContext } from "../../context/FormContext";
import { usePublicScreenContext } from "../../context/PublicScreenContext";
import { FormLayoutWithEdit } from "../Form/FormSection";
import RightSideFieldsBar from "../Form/RightSideFieldsBar";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";
import Button from "../../components/FormComponents/Button";
import BuilderTabs from "../../Layouts/BuilderTabs";

const PublicFormRenderer = () => {
  const { renderFieldsData, renderFieldsArray } = useFormContext();
  const { savePublicScreenJson, selectedPublicScreen, currentPublicScreenData, setCurrentPublicScreenData } =
    usePublicScreenContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("form");
  const [dragFromOutside, setDragFromOutside] = useState(false);

  const handleEditFormData = (data) => {
    const newData = { ...currentPublicScreenData, ...data };
    setCurrentPublicScreenData(newData);
    setIsModalOpen(false);
  };

  const handleDragStart = useCallback(
    (e, name) => {
      e.dataTransfer.setData("type", name);
      setDragFromOutside(true);
    },
    [setDragFromOutside]
  );

  const memoizedRightSideFieldsBar = useMemo(() => {
    return <RightSideFieldsBar handleDragStart={handleDragStart} />;
  }, [handleDragStart]);

  return (
    <>
      <div>
        <PageInfoAndActionBar
          pagePath={`Public Form/${selectedPublicScreen.name}`}
          savePage={savePublicScreenJson}
          settingPage={() => setIsModalOpen(true)}
          currentConfig={[
            renderFieldsArray,
            renderFieldsData.current,
            currentPublicScreenData.custom_js,
            currentPublicScreenData.submit_button
          ]}
          pageName="publicaccess"
        />
        <div style={{ position: "relative", top: "4px", left: "8px" }}>
          <div style={{ position: "absolute", top: "0", left: "0", zIndex: "1" }}>
            <BuilderTabs
              tabs={[
                { label: "form", content: null },
                { label: "custom js", content: null }
              ]}
              onChange={setSelectedTab}
            />
          </div>
        </div>
        {selectedTab === "form" && (
          // <FormSection from="publicform" />
          <div className="form_outer_section">
            <FormLayoutWithEdit
              dragFromOutside={dragFromOutside}
              setDragFromOutside={setDragFromOutside}
              isDesktopModeOpen={false}
              from="appuser"
              tableID="publicform"
            />
            <div className="rightsidebar">{memoizedRightSideFieldsBar}</div>
          </div>
        )}
        {selectedTab === "custom js" && (
          <div style={{ marginTop: "48px", display: "flex", flexDirection: "column", padding: "20px" }}>
            <Textarea
              label="Custom JS"
              type="text"
              value={currentPublicScreenData.custom_js}
              name="custom_js"
              onChange={(e) => setCurrentPublicScreenData({ ...currentPublicScreenData, custom_js: e.target.value })}
            />
          </div>
        )}
      </div>
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Edit Form Setting">
        <FormInfo currentPublicScreenData={currentPublicScreenData} handleEditFormData={handleEditFormData} />
      </BuilderModal>
    </>
  );
};

export default PublicFormRenderer;

const FormInfo = ({ currentPublicScreenData, handleEditFormData }) => {
  const [formData, setFormData] = useState({
    submit_button: currentPublicScreenData.submit_button || ""
    // custom_js: currentPublicScreenData.custom_js || ""
  });

  const changeFormData = (e) => {
    const newData = { ...formData, [e.target.name]: e.target.value };
    setFormData(newData);
  };

  return (
    <div className="builder_form">
      <Input label="Submit Button" value={formData.submit_button} name="submit_button" onChange={changeFormData} />
      {/* <label className="builder_label">Custom JS</label>
      <textarea
        style={{ height: "50vh", marginBottom: "18px" }}
        type="text"
        value={formData.custom_js}
        name="custom_js"
        onChange={changeFormData}
      /> */}
      <Button onClick={() => handleEditFormData(formData)}>Edit</Button>
    </div>
  );
};
